// extracted by mini-css-extract-plugin
export var brand = "_8f-9";
export var compact = "_8f-6";
export var extraSmall = "_8f-7";
export var icon = "_8f-0";
export var large = "_8f-4";
export var light = "_8f-1";
export var medium = "_8f-5";
export var outline = "_8f-b";
export var primaryDark = "_8f-a";
export var primaryLight = "_8f-8";
export var primaryModern = "_8f-c";
export var success = "_8f-2";
export var successSolid = "_8f-3";